export default __webpack_public_path__ + "static/33-8223992709649bd38ec3e143a80fad39.gif";